import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  input,
  Input,
  Output,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { KeyFilterModule, KeyFilterPattern } from 'primeng/keyfilter';
import { TrimInputDirective } from '../../../../shared/directives/trim-input.directive';
import { CoreControlDirective } from '../../../utils/core-control.directive';
import { InputHelpTextComponent } from '../input-help-text/input-help-text.component';
import { InputTextVariant } from './contract/input-text-variant.contract';

@Component({
  selector: 'osp-input-text',
  templateUrl: './input-text.component.html',
  styleUrl: './input-text.component.scss',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    InputTextModule,
    KeyFilterModule,
    DropdownModule,
    TrimInputDirective,
    InputHelpTextComponent,
],
  encapsulation: ViewEncapsulation.None,
  providers: CoreControlDirective.coreControlProvider(InputTextComponent),
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputTextComponent extends CoreControlDirective {
  @HostBinding('class.osp-input-text') protected hostCssClassEnabled = true;
  @ViewChild('inputElem') protected inputRef!: ElementRef;

  @Input() variant: InputTextVariant = 'outlined';
  @Input() placeholder: string = '';
  @Input() cssClass = '';
  @Input() readOnly = false;
  @Input() keyFilter: RegExp | KeyFilterPattern | null | undefined;
  @Input() helpText: string = '';
  $trimEnabled = input(true, { alias: 'trimEnabled' });

  @Output() onFocus = new EventEmitter<FocusEvent>();
  @Output() onFocusOut = new EventEmitter<FocusEvent>();
  @Output() onBlur = new EventEmitter<FocusEvent>();
  @Output() onInput = new EventEmitter<Event>();

  get inputNativeElement(): HTMLInputElement {
    return this.inputRef.nativeElement;
  };

  focus(): void {
    this.inputNativeElement.focus();
  }
}
